import React from 'react';
import { cn } from '@/utils/cn';
import Link from 'next/link';

function Outline({
  as,
  href,
  children,
  className = '',
  disabled = false,
  ...rest
}) {
  if (as === 'a') {
    return (
      <Link
        prefetch={false}
        aria-label="Go to outline button"
        href={href}
        className={cn(
          `px-24 py-10 rounded-[100px] flex justify-center items-center bg-transparent border border-white ${className}`,
          { 'bg-disabled': disabled },
        )}
      >
        {children}
      </Link>
    );
  }
  return (
    <button
      type="button"
      aria-label="outline button"
      className={cn(
        `px-24 py-10 rounded-[100px] flex justify-center items-center bg-transparent border border-white hover:bg-placebo-green`,
        className,
        {
          'bg-disabled': disabled,
        },
      )}
      disabled={disabled}
      {...rest}
    >
      {children}
    </button>
  );
}

export default Outline;
